<template>
  <b-card no-gutters :sub-title="trans('subscribe_newsletter')">
    <b-card-text>
      <b-form-row v-if="!isSent && !vertical">
        <b-col cols="12" sm="3" class="mb-2">
          <b-form-input size="sm" v-model="name" :placeholder="trans('name')" />
        </b-col>
        <b-col cols="12" sm="3" class="mb-2">
          <b-form-input size="sm" v-model="mobile" :placeholder="trans('mobile') + ' 555-123-1234'" />
        </b-col>
        <b-col cols="12" sm="4" class="mb-2">
          <b-form-input size="sm" v-model="email" :placeholder="trans('email')" />
        </b-col>
        <b-col cols="12" sm="2">
          <b-button size="sm" type="submit" variant="info" @click="submit" :disabled="isBusy">
            <span v-if="!isBusy">{{ trans('list_subscribe') }}</span>
            <i v-if="isBusy" class="fa fa-fw fa-spin fa-circle-notch mx-4"></i>
          </b-button>
        </b-col>
      </b-form-row>
      <b-form v-if="!isSent && vertical">
        <b-form-group class="mt-3">
          <b-form-input size="sm" v-model="name" :placeholder="trans('name')" />
        </b-form-group>
        <b-form-group>
          <b-form-input size="sm" v-model="mobile" :placeholder="trans('mobile')" />
        </b-form-group>
        <b-form-group>
          <b-form-input size="sm" v-model="email" :placeholder="trans('email')" />
        </b-form-group>
        <b-form-group>
          <b-button size="sm" type="submit" variant="info" @click="submit" :disabled="isBusy">
            <span v-if="!isBusy">{{ trans('list_subscribe') }}</span>
            <i v-if="isBusy" class="fa fa-fw fa-spin fa-circle-notch mx-4"></i>
          </b-button>
        </b-form-group>
      </b-form>
      <div v-if="error" class="text-danger">
        {{ error }}
      </div>
      <div v-if="isSent" class="text-success">
        <i class="fa fa-fw fa-check"></i>
        {{ trans('subscribe_newsletter_success') }}
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
  export default {
    props: [
      'vertical',
    ],
    data() {
      return {
        trans: trans,
        isBusy: false,
        isSent: false,
        error: false,
        name: null,
        mobile: null,
        email: null,
      }
    },
    methods: {
      submit() {
        this.isBusy = true
        this.error = null
        axios.post('/px/fLXQRkg', {
          type: 'subscribers',
          name: this.name,
          mobile: this.mobile,
          email: this.email,
        })
        .then(response => {
          this.isBusy = false
          this.isSent = true
        })
        .catch(error => {
          this.isBusy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.newsletterComponent = this
    }
  }
</script>